
import { defineComponent, PropType } from 'vue'
import { BillingInfo } from '~/types/types'
export default defineComponent({
  name: 'BillingCQSettings',
  data() {
    return {
      chevronIconAnimateClass: ''
    }
  },
  props: {
    billingInfo: {
      type: Object as PropType<BillingInfo>,
      default: () => ({})
    },
    showDowngrade: {
      type: Boolean,
      default: false
    },
    showResume: {
      type: Boolean,
      default: false
    },
    showCancel: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    /**
     * Handler for the `isOpen` event emitted by `ZAccordionItem`
     *
     * @param {boolean} open
     * @returns {void}
     */
    isOpenHandler(open: boolean): void {
      this.chevronIconAnimateClass = open
        ? 'animate-first-quarter-spin rotate-90'
        : 'animate-reverse-quarter-spin rotate-0'
    }
  }
})
